import { Check, Lock } from "lucide-react";

// Visual 10-state lifecycle timeline
export const Timeline = ({ states, current, onSelect, lockedStates = [] }) => {
  const currentIdx = states.indexOf(current);
  const lockedSet = new Set(lockedStates);
  return (
    <div className="w-full" data-testid="book-timeline">
      <div className="flex flex-col gap-0">
        {states.map((state, i) => {
          const done = i < currentIdx;
          const active = i === currentIdx;
          const locked = lockedSet.has(state);
          return (
            <button
              key={state}
              type="button"
              onClick={() => onSelect && onSelect(state)}
              data-testid={`timeline-step-${state}`}
              className="group flex items-center gap-4 text-left"
            >
              <div className="flex flex-col items-center">
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border text-xs font-medium transition-colors duration-300 ${
                    active
                      ? "border-[#D4AF37] bg-[#D4AF37] text-[#050A15]"
                      : done
                      ? "border-[#D4AF37]/50 bg-[#D4AF37]/10 text-[#D4AF37]"
                      : "border-white/10 bg-transparent text-white/40"
                  }`}
                >
                  {locked ? <Lock className="h-3.5 w-3.5" /> : done ? <Check className="h-4 w-4" /> : i + 1}
                </span>
                {i < states.length - 1 && (
                  <span
                    className={`h-8 w-px transition-colors duration-300 ${
                      done ? "bg-[#D4AF37]/50" : "bg-white/10"
                    }`}
                  />
                )}
              </div>
              <span
                className={`pb-8 text-sm transition-colors duration-300 ${
                  active
                    ? "text-white font-medium"
                    : done
                    ? "text-white/70"
                    : "text-white/40 group-hover:text-white/60"
                }`}
              >
                {state}
                {active && (
                  <span className="ml-2 text-[10px] uppercase tracking-[0.2em] text-[#D4AF37]">
                    · in corso
                  </span>
                )}
                {locked && !active && (
                  <span className="ml-2 text-[10px] uppercase tracking-[0.2em] text-white/30">
                    · da pagare
                  </span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
